import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { TWMenu } from '../TWMenu';
import { Avatar } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWAvatarDropdown = function TWAvatarDropdown(_ref) {
  var avatar = _ref.avatar,
      classes = _ref.classes,
      items = _ref.items,
      initials = _ref.initials;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var toggleOpen = function toggleOpen(event) {
    event.nativeEvent.stopImmediatePropagation();
    setOpen(!open);
  };

  var closeDropdown = function closeDropdown() {
    setOpen(false);
  };

  useEffect(function () {
    document.addEventListener('click', closeDropdown);
    return function () {
      return document.removeEventListener('click', closeDropdown);
    };
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('inline-block relative', classes),
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("button", {
        className: "bg-white rounded-full flex focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-subkit-primary",
        id: "user-menu",
        "aria-haspopup": "true",
        onClick: toggleOpen,
        children: [/*#__PURE__*/_jsx("span", {
          className: "sr-only",
          children: "Open user menu"
        }), /*#__PURE__*/_jsx(Avatar, {
          avatar: avatar,
          initials: initials
        })]
      })
    }), open && /*#__PURE__*/_jsx("div", {
      className: "border border-gray-100 origin-top-right absolute right-0 mt-2 w-max rounded-md shadow-lg py-4 bg-white z-10",
      role: "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "user-menu",
      children: /*#__PURE__*/_jsx(TWMenu, {
        items: items
      })
    })]
  });
};
TWAvatarDropdown.defaultProps = {
  classes: ''
};